import React from 'react';
import TemplateContainer from 'components/organisms/TemplateContainer/TemplateContainer';

export default function SingleTemplate () {
    return (
      <TemplateContainer />
    );
    }
